import { RouteObject } from 'react-router';

import { DefaultLayout } from '@/ui/pages/app/components/layouts/DefaultLayout';
import { EditProjectTour } from '@/ui/pages/app/project/tour/edit-project/EditProjectTour';
import { TourOnTour } from '@/ui/pages/app/project/tour/ontour/TourOnTour';
import { ProjectTour } from '@/ui/pages/app/project/tour/project/ProjectTour';
import { ProjectsTour } from '@/ui/pages/app/project/tour/projects/ProjectsTour';

import {
  tourIndexLoader,
  tourLoader,
  tourOntourLoader,
  toursLoader,
} from './tourLoaders';

export const tourRoutes: RouteObject[] = [
  {
    path: 'projects/tour',
    loader: tourIndexLoader,
    children: [
      {
        path: '',
        loader: toursLoader,
        element: (
          <DefaultLayout>
            <ProjectsTour />
          </DefaultLayout>
        ),
      },
      {
        path: ':id',
        loader: tourLoader,
        element: (
          <DefaultLayout enableMargin={false}>
            <ProjectTour />
          </DefaultLayout>
        ),
      },
      {
        path: ':id/edit',
        loader: tourLoader,
        element: (
          <DefaultLayout>
            <EditProjectTour />
          </DefaultLayout>
        ),
      },
      {
        path: ':id/ontour/:sequenceId',
        loader: tourOntourLoader,
        element: (
          <DefaultLayout>
            <TourOnTour />
          </DefaultLayout>
        ),
      },
    ],
  },
];
